import { API_DOMAIN } from '@constants/app-constants';
import { call, put, takeEvery } from 'redux-saga/effects';
import Actions from '../action';
import Axios from 'axios';

export function* getCompanyAgreementWorker(action) {
	try {
		let companyId = localStorage.getItem('companyId');
		const uri = `${API_DOMAIN}/Company/` + companyId;
		let res = yield call(Axios.get, uri);
		yield put(Actions.creators.getCompanyAgreementSuccess(res.data.company));
	} catch (err) {
		yield put(Actions.creators.getCompanyAgreementError());
	}
}

export default function* opportunityWatcher() {
	yield takeEvery(Actions.types.GET_COMPANY_AGREEMENT_START, getCompanyAgreementWorker);
}
